import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {withAnswer} from '#components/HOC/withAnswerHOC'
import Radio from '#components/a/form/Radio'
import QuestionDescription from './QuestionDescription'

export class QuestionSingleChoice extends React.Component {
  defaultAnswer = {selectedIndex: undefined}

  onSelectRadio = async index => {
    await this.props.saveAnswer({selectedIndex: index})
  }

  render() {
    const {question, isReadOnly} = this.props
    const answer = this.props.currentAnswer || this.defaultAnswer
    const radios = question.content.map(a => (
      <Radio
        size="large"
        key={a.order}
        checked={answer.selectedIndex === a.order}
        onChangeHandle={() => this.onSelectRadio(a.order)}
        labelText={a.text}
        disabledState={isReadOnly}
      />
    ))
    return (
      <>
        {this.props.children}
        <QuestionDescription question={question} />
        {radios}
      </>
    )
  }
}

QuestionSingleChoice.propTypes = {
  saveAnswer: PropTypes.func.isRequired,
  question: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  currentAnswer: PropTypes.object,
  children: PropTypes.node,
}

export default withAnswer(QuestionSingleChoice)
